import React from 'react';
import { Navigate } from 'react-router-dom';
import { Card } from '../../components/ui/card';
import { ChatPanel } from '../../components/ChatPanel';
import { useAuth } from '../../AuthContext';
import { Hash, Lock, Users as UsersIcon, MessageCircle } from 'lucide-react';

const CHANNELS = [
  { id: 'team', name: 'team', label: '# team', description: 'Default channel — operations & ops chatter', active: true },
];

export default function TeamChat() {
  const { user, loading } = useAuth();
  if (loading) return <div className='p-10 text-slate-500'>Loading…</div>;
  if (!user) return <Navigate to='/login' replace />;
  if (!['ADMIN', 'TRAINER', 'FRONT_DESK'].includes(user.role)) {
    return <Navigate to='/admin' replace />;
  }

  return (
    <div className='p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto'>
      <div className='flex items-center justify-between mb-5 flex-wrap gap-3'>
        <div>
          <div className='text-[10px] uppercase tracking-[0.16em] font-bold text-[#C8102E]'>Internal</div>
          <h1 className='font-display text-2xl sm:text-3xl font-bold text-[#0B1220] dark:text-slate-50 mt-1 flex items-center gap-2'>
            <MessageCircle className='w-7 h-7 text-[#1B3A87] dark:text-[#93C5FD]' /> Team Chat
          </h1>
          <p className='text-slate-500 dark:text-slate-400 text-sm mt-1'>
            A Slack-style channel for JFK9 staff only. Clients cannot view or post here.
          </p>
        </div>
        <div className='inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#1B3A87]/10 dark:bg-[#1B3A87]/30 text-[#1B3A87] dark:text-[#93C5FD] text-xs font-semibold'>
          <Lock className='w-3.5 h-3.5' /> Staff Only
        </div>
      </div>

      <div className='grid lg:grid-cols-[240px_1fr] gap-4'>
        {/* Channels rail */}
        <Card className='p-3 border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 h-fit lg:sticky lg:top-20'>
          <div className='text-[10px] uppercase tracking-[0.18em] font-bold text-slate-500 dark:text-slate-400 px-2 py-1.5'>
            Channels
          </div>
          {CHANNELS.map((c) => (
            <button
              key={c.id}
              className={`w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium ${
                c.active
                  ? 'bg-[#1B3A87] text-white'
                  : 'text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800'
              }`}
              data-testid={`team-channel-${c.id}`}
            >
              <Hash className='w-3.5 h-3.5 opacity-70' /> {c.label.replace('# ', '')}
            </button>
          ))}
          <div className='text-[10px] uppercase tracking-[0.18em] font-bold text-slate-500 dark:text-slate-400 px-2 py-1.5 mt-3'>
            Members
          </div>
          <div className='px-3 py-2 text-xs text-slate-500 dark:text-slate-400 flex items-center gap-2'>
            <UsersIcon className='w-3.5 h-3.5' /> Admins, Trainers, Front Desk
          </div>
          <div className='px-3 py-1 text-[11px] text-slate-400 dark:text-slate-500'>
            More channels coming soon (#training, #front-desk).
          </div>
        </Card>

        {/* Chat panel */}
        <div>
          <ChatPanel
            channel='team'
            title='# team'
            subtitle='Internal staff channel · Admins, Trainers, Front Desk'
            canPost={true}
            height='h-[calc(100vh-260px)] min-h-[420px]'
          />
        </div>
      </div>
    </div>
  );
}
